import React from "react";
import "./Home.css";

const Contents = ({ setActiveScreen, name, content, screen }) => {

    const jumpPageFromTopPage = (screen) => {
        setActiveScreen(screen);
    }
    return (
        <div>
            <div className="contents-element-wrapper">
                <div className="contents-name" onClick={()=>jumpPageFromTopPage(screen)}>
                    <span className="contents-name-name">{name}</span>
                </div>
                <div className="contents-content">
                    {content}
                </div>

            </div>
        </div>
    );
}
export default Contents;